import { __decorate } from "tslib";
import { Component, Prop, Mixins } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { mapGetters, mapMutations } from "vuex";
import ModalMixin from "@/mixins/modal-mixin";
import InvoiceTable from "@/components/Invoice/InvoiceTable.vue";
import mergeInvoices from "@/util/invoice-merge";
let CombinedInvoicePrintModal = class CombinedInvoicePrintModal extends Mixins(ModalMixin) {
    id;
    removeFromStore;
    findInvoicesStore;
    invoiceIds = [];
    customerId = '';
    getMyCompany;
    getCustomer;
    get billing() {
        return { ...this.company.billing, avatar: this.company.avatar };
    }
    get invoices() {
        return this.findInvoicesStore({ query: { _id: { $in: this.invoiceIds } } }).data;
    }
    get company() {
        return this.getMyCompany('mine');
    }
    get customer() {
        return this.getCustomer(this.customerId);
    }
    get combinedInvoice() {
        return mergeInvoices(this.invoices);
    }
    hidden() {
        var $printSection = document.getElementById("printSection");
        if ($printSection) {
            $printSection.remove();
        }
    }
    print() {
        // @ts-ignore
        var domClone = document.getElementById('printContent').cloneNode(true);
        let printSection = document.getElementById("printSection");
        if (!printSection) {
            printSection = document.createElement("div");
            printSection.id = "printSection";
            document.body.appendChild(printSection);
        }
        // @ts-ignore
        printSection.innerHTML = "";
        // @ts-ignore
        printSection.appendChild(domClone);
        window.onafterprint = () => {
            this.close();
        };
        setTimeout(function () {
            window.print();
        }, 500);
    }
    shown() {
        const { Invoice } = this.$FeathersVuex;
        let data = Invoice.getFromStore('temp');
        if (!data)
            return;
        this.invoiceIds = data.model.selected;
        this.customerId = data.model.customerId;
        this.removeFromStore('temp');
        setTimeout(this.print, 0); // makes sure content is rendered before printing the page
    }
    close() {
        this.$root.$emit('bv::hide::modal', this.id);
    }
};
__decorate([
    Prop({ type: String, required: true })
], CombinedInvoicePrintModal.prototype, "id", void 0);
CombinedInvoicePrintModal = __decorate([
    Component({
        components: { InvoiceTable, Modal },
        methods: {
            ...mapMutations('invoices', { removeFromStore: 'removeItem' }),
        },
        computed: {
            ...mapGetters('invoices', { findInvoicesStore: 'find' }),
            ...mapGetters('invoices', { getInvoice: 'get' }),
            ...mapGetters('my-company', { getMyCompany: 'get' }),
            ...mapGetters('customers', { getCustomer: 'get' }),
        }
    })
], CombinedInvoicePrintModal);
export default CombinedInvoicePrintModal;
